module.exports = __webpack_public_path__ + "img/15.7dab5a97.jpg";